import { useOperator } from "globals/hooks";
import { PRIVACY_POLICY } from "pages/privacy-policy/privacyPolicy";

type Term = {
  id: string;
  name: string;
  description: string;
}

function usePrivacyPolicy() {
  const { operator } = useOperator();
  const companyName = operator?.name;

  const privacyPolicy: Term[] = PRIVACY_POLICY.map(term => ({
    ...term,
    description: term.description.replace(/\[Company\]/g, companyName)
  }));

  return privacyPolicy;
}

export { usePrivacyPolicy };